import React, { useMemo } from 'react';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { useDataGridDateRangeFilter } from '../../../../common/DataGrid/filters/useDataGridDateRangeFilter.jsx';
import {
  dataGridTextSorter,
  dataGridDateSorter,
} from '../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import PropTypes from 'prop-types';
import { Spinner } from '../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';

const NewsCategoryTable = ({ newsCategories, onDetailClick }) => {
  const { t } = useTranslation();
  const titleTextFilterProps = useDataGridTextFilter('name');
  const addedDateRangeFilterProps = useDataGridDateRangeFilter('created_at');

  const columns = useMemo(
    () => [
      {
        title: t('Názov kategórie'),
        dataIndex: 'name',
        ellipsis: true,
        sorter: dataGridTextSorter('name'),
        defaultSortOrder: 'ascend',
        ...titleTextFilterProps,
      },
      {
        title: t('Pridaná'),
        dataIndex: 'created_at',
        sorter: dataGridDateSorter('created_at'),
        render: (date) => (date && new Date(date).toLocaleDateString()) || '-',
        ...addedDateRangeFilterProps,
        width: 170,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [titleTextFilterProps, addedDateRangeFilterProps],
  );

  if (!newsCategories) {
    return <Spinner />;
  }

  return (
    <>
      <DataGrid
        rowKey={(category) => category.id}
        columns={columns}
        dataSource={newsCategories || []}
        permissionsBasic={'news-categories'}
        uniqueTableId={'news-categories-table'}
        onRowClick={onDetailClick}
        onEditClick={onDetailClick}
      />
    </>
  );
};

NewsCategoryTable.propTypes = {
  newsCategories: PropTypes.array,
  onDetailClick: PropTypes.func,
  onCreateClick: PropTypes.func,
};

export default NewsCategoryTable;
